<div class="p-grid cre-day-panel-justify-content">
  <div *ngFor="let day of days; let i = index">
    <div
      class="cre-day-panel"
      [ngClass]="{ 'cre-day-panel-disabled': day.disabled, 'cre-day-panel-selected': day.selected }"
      (click)="clickDay(i)"
    >
      <span class="cre-day-panel-day" [ngClass]="{ 'cre-day-panel-selected': day.selected }">{{
        day.date | date: 'EEE'
      }}</span>
      <span
        class="cre-day-panel-date"
        [ngClass]="{ 'cre-day-panel-selected': day.selected }"
        *ngIf="!day.disabled"
        >{{ day.date | date: 'dd' }}</span
      >
      <span class="cre-day-panel-date" *ngIf="day.disabled"
        ><fa-icon
          class="cre-day-panel-icon"
          [icon]="day.iconConfiguration"
          [ngClass]="{
            'cre-day-panel-icon-disabled': day.disabled,
            'cre-day-panel-selected': day.selected
          }"
        ></fa-icon
      ></span>
      <span
        class="cre-day-panel-ellipse"
        [ngClass]="{ 'cre-day-panel-ellipse-selected': day.selected }"
        *ngIf="!day.disabled"
      ></span>
    </div>
  </div>
</div>
